<template>
  <v-dialog @keydown.esc="isOpen=false" v-model="isOpen" persistent max-width="500px">
    <v-card>
      <v-card-title>
        <span class="headline">Selecciona la cuenta y el tipo de ingreso para crear un movimiento de depósito por el total del Efectivo corte actualizado</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="newDeposit" v-model="form.valid">
          <v-container grid-list-xl>
            <v-layout wrap>
              <v-flex xs12 md12>
                <v-select
                  :items="banks.data"
                  item-text="name"
                  item-value="_id"
                  :disabled="!banks.data.length"
                  v-model="form.data.bank"
                  label="Cajas"
                  required
                />
              </v-flex>
              <v-flex xs12 md12>
                <v-select
                  item-text="name"
                  item-value="_id"
                  :items="incomeCategories"
                  :label="$t('expenses.registerMovements.movements.drawerAdd.incomeType')"
                  v-model="form.data.incomeType"
                  required>
                </v-select>
              </v-flex>
              <v-flex xs12 md12>
                <v-text-field
                  label="Folio"
                  v-model="form.data.folio"
                />
              </v-flex>
              <v-flex xs12 md12>
                <v-text-field
                  label="Monto"
                  v-model="amount"
                  disabled
                  placeholder="amount"
                  prefix="$"
                  readonly
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="mr-4"
          outlined
          rounded
          small
          depressed
          @click="closeDialog">
          {{ $t('orders.buttons.close') }}
        </v-btn>
        <v-btn
          data-cy="success"
          color="success"
          class="mr-4"
          rounded
          small
          depressed
          @click="submit">
          {{ $t('orders.buttons.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
export default {
  props: {
    amount: {
      type: Number,
      default: 0,
      required: true
    },
    cashCloseDate: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      overlay: false,
      isOpen: false,
      form: {
        valid: false,
        data: {
          bank: null,
          incomeType: null,
          folio: null,
          amount: null,
          type: 'deposit',
          date: '',
          concept: ''
        }
      },
      banks: {
        loading: false,
        data: []
      },
      incomeCategories: []
    }
  },
  watch: {
    isOpen (val) {
      if (val) {
        this.resetDepositForm()
      }
    }
  },
  async mounted () {
    await this.loadBanks()
    await this.getIncomeCategory()
    this.form.data.amount = this.amount
  },
  methods: {
    submit: async function () {
      this.$refs.newDeposit.validate()

      if (this.form.valid) {
        this.overlay = true
        try {
          this.form.data.amount = this.amount
          this.form.data.date = this.cashCloseDate
          this.form.data.concept = `Depósito de corte definitivo ${this.$moment(this.cashCloseDate).format('YYYYMMDD')}`
          await this.$api.post(`/v1/transfers`, this.form.data)
          this.closeDialog()
          this.$toasted.show('Se creó el depósito de manera exitosa.', { duration: 5000 })
          this.$emit('updateDefinitiveState')
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    },
    async loadBanks (params = null) {
      params = params || {
        restaurant: this.$store.state.currentRestaurant.data._id,
        kind: 'cash'
      }

      this.banks.loading = true
      try {
        const response = await this.$api.get(`/v1/financial/balance-accounts`, params)
        this.banks.data = response
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.banks.loading = false
    },
    async getIncomeCategory (params = null) {
      params = params || {
        kind: 'income',
        restaurant: this.$store.state.currentRestaurant.data._id
      }
      this.overlay = true
      try {
        const response = await this.$api.get(`/v1/cashflows/types`, params)
        response.data.map(item => {
          const data = {
            name: item.name,
            _id: item._id
          }
          this.incomeCategories.push(data)
        })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    resetDepositForm () {
      this.form.data = {
        bank: null,
        incomeType: null,
        folio: null,
        amount: null,
        type: 'deposit',
        date: '',
        concept: 'Depósito de corte definitivo'
      }
    },
    closeDialog () {
      this.isOpen = false
      this.$emit('close', false)
    },
    open () {
      this.isOpen = true
    }
  }
}
</script>
